import {MonsterType} from "./CardTypes";

export type MonsterFrames = {
    idleFrames: string[]
    attackFrames: string[]
}

export const SimpleMonsterFrames: MonsterFrames = {
    idleFrames: ['Skeleton idle1', 'Skeleton idle2', 'Skeleton idle3', 'Skeleton idle4',
        'Skeleton idle5', 'Skeleton idle6', 'Skeleton idle7', 'Skeleton idle8'],
    attackFrames: ['Skeleton attack0',
        'Skeleton attack1', 'Skeleton attack2', 'Skeleton attack3', 'Skeleton attack4',
        'Skeleton attack5']
}

export const BossMonsterFrames: MonsterFrames = {
    idleFrames: ['Skeleton boss idle1', 'Skeleton boss idle2', 'Skeleton boss idle3', 'Skeleton boss idle4',
        'Skeleton boss idle5', 'Skeleton boss idle6', 'Skeleton boss idle7', 'Skeleton boss idle8'],
    attackFrames: ['Skeleton boss attack0',
        'Skeleton boss attack1', 'Skeleton boss attack2', 'Skeleton boss attack3', 'Skeleton boss attack4',
        'Skeleton boss attack5', 'Skeleton boss attack6', 'Skeleton boss attack7', 'Skeleton boss attack8',
        'Skeleton boss attack9']
}

export function getMonsterFrames(monsterType: MonsterType) {
    if (monsterType === MonsterType.SIMPLE) {
        return SimpleMonsterFrames
    }
    else if (monsterType === MonsterType.BOSS) {
        return BossMonsterFrames
    }
    else {
        throw new Error(`Unknown monster type: ${monsterType}`)
    }
}